// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3bpGq","header":"Messages_header__1MYdD"};